import { Component, HostListener, Inject, AfterViewInit, ViewChild, OnInit} from '@angular/core';
import { MessageService, MessageAcntModel, MessageModel } from '../../../../services/index';


@Component({
    selector:'msg-mangmt-list',
    templateUrl: 'msg-mangmt-list.html'
})

export class MsgMangmtList implements OnInit {
    tabIndex:number = 0;
    
    private messageAcntList:Array<MessageAcntModel> = new Array<MessageAcntModel>();
    private messageList:Array<MessageModel> = new Array<MessageModel>();

    constructor(private messageService:MessageService){
        
    }
    
    ngOnInit(){
        this.messageService.getMessageAcntList().subscribe((resultList:Array<MessageAcntModel>)=>{
            this.messageAcntList = resultList;
        });

        this.messageService.getMessageList().subscribe((resultList:Array<MessageModel>)=>{
            this.messageList = resultList;
        });
    }

    addAction(){
        this.messageAcntList.push(new MessageAcntModel());
    }

    addMessage(){
        let msg:MessageModel = new MessageModel();
        msg.messageKind = 'ALL';
        msg.isImportance = 0;
        msg.isWarning = 0;
        this.messageList.push(msg);
    }

    deleteAction(idx:number){
        this.messageAcntList.splice(idx,1);
    }

    deleteMessage(idx:number){
        let msg:MessageModel  = this.messageList[idx];
        this.messageList.splice(idx,1);
        if(msg.messageId){
            this.messageService.delMsgMaster(msg.messageId).subscribe((result:any)=>{
                this.messageList = result;
            });
        }
    }

    saveAction(){
        this.messageService.saveAction({messageAcntList:this.messageAcntList}).subscribe((result:any)=>{
            this.messageList == null
        });
    }

    saveMessage(){
        this.messageService.saveMessage({messageList:this.messageList}).subscribe((result:any)=>{
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/containers/message/management/msg-mangmt-list/msg-mangmt-list.ts